import { Injectable, inject } from '@angular/core';
import { Firestore, doc, getDoc, setDoc } from '@angular/fire/firestore';

@Injectable({ providedIn: 'root' })
export class UserLookupService {
  private firestore = inject(Firestore);
  private cache: Record<string, string> = {};

  async getDisplayName(uid: string): Promise<string> {
    if (!uid) return '';
    if (this.cache[uid] !== undefined) return this.cache[uid];
    try {
      const snap = await getDoc(doc(this.firestore, `usernames/${uid}`));
      const name = snap.exists() ? ((snap.data()['displayName'] as string) || '') : '';
      this.cache[uid] = name;
      return name;
    } catch {
      return '';
    }
  }

  async resolveMany(uids: string[]): Promise<Record<string, string>> {
    const unique = [...new Set(uids.filter(Boolean))];
    await Promise.all(unique.map(uid => this.getDisplayName(uid)));
    const result: Record<string, string> = {};
    for (const uid of unique) {
      result[uid] = this.cache[uid] || '';
    }
    return result;
  }

  async writeUsername(uid: string, displayName: string): Promise<void> {
    if (!uid || !displayName) return;
    this.cache[uid] = displayName;
    await setDoc(doc(this.firestore, `usernames/${uid}`), { displayName });
  }
}
